class CustomizedBoostFilter extends HTMLElement {
    constructor() {
      super();
      this.filterOption = $('.boost-pfs-container-default.boost-pfs-filter-style-2 .boost-pfs-filter-option .boost-pfs-filter-option-title');
    }

    removeAllFilters(){
      const currentLocationPath = window.location.pathname;
      const newUrlPath = window.location.hostname + window.location.pathname
      window.history.pushState('data', 'test', window.location.href.split('?')[0]);
      const selectedFilterItems = $('.boost-pfs-filter-option-item.boost-pfs-filter-option-label.selected');
      selectedFilterItems.removeClass('selected')
      selectedFilterItems.find('.boost-pfs-filter-button').attr('aria-checked', 'false')
      return this.repo;
    }

}

customElements.define('boost-pfs-container-default.boost-pfs-filter-style-2', CustomizedBoostFilter);

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

$(window).on("load", function () {
  const boostFilter = new CustomizedBoostFilter;
});